"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dialog_styled_exports = {};
__export(Dialog_styled_exports, {
  StyledBody: () => StyledBody,
  StyledContentWrapper: () => StyledContentWrapper,
  StyledFooter: () => StyledFooter,
  StyledFooterLeftContainer: () => StyledFooterLeftContainer,
  StyledFooterRightContainer: () => StyledFooterRightContainer,
  StyledHeader: () => StyledHeader,
  StyledHeaderLeftContainer: () => StyledHeaderLeftContainer
});
module.exports = __toCommonJS(Dialog_styled_exports);
var import_styled_components = require("styled-components");
var import_styled_components2 = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_atoms = require("../../atoms");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var StyledContentWrapper = (0, import_styled_components2.default)(import_atoms.Card).withConfig({
  displayName: "Dialogstyled__StyledContentWrapper",
  componentId: "sc-1g1a82p-0"
})(["", ";", ";", ";", ";"], {
  "display": "flex",
  "width": "auto",
  "flexDirection": "column",
  "overflowY": "auto",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "0px",
  "--tw-shadow": "0px 10px 16px 0px rgba(14, 25, 27, 0.24), 0px 2px 4px 0px rgba(14, 25, 27, 0.08)",
  "--tw-shadow-colored": "0px 10px 16px 0px var(--tw-shadow-color), 0px 2px 4px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 1024px)": {
    "overflowY": "hidden"
  }
}, {
  "minWidth": "304px",
  "maxWidth": "calc(100% - 16px)"
}, {
  "height": "auto",
  "maxHeight": "calc(100% - 32px)"
}, (0, import_mixins.withStyledScrollBar)());
var StyledHeader = import_styled_components2.default.div.withConfig({
  displayName: "Dialogstyled__StyledHeader",
  componentId: "sc-1g1a82p-1"
})(function(_ref) {
  var theme = _ref.theme, hideSeparator = _ref.hideSeparator;
  return (0, import_styled_components.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-bottom: ", ";\n    ", ";\n  "])), hideSeparator ? "none" : "1px solid ".concat(theme.colors.beige[180]), {
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "alignItems": "center",
    "backgroundColor": "transparent",
    "padding": "1rem"
  });
});
var StyledHeaderLeftContainer = import_styled_components2.default.div.withConfig({
  displayName: "Dialogstyled__StyledHeaderLeftContainer",
  componentId: "sc-1g1a82p-2"
})(function() {
  return (0, import_styled_components.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    ", ";\n  "])), {
    "display": "flex",
    "alignItems": "center"
  });
});
var StyledFooter = import_styled_components2.default.div.withConfig({
  displayName: "Dialogstyled__StyledFooter",
  componentId: "sc-1g1a82p-3"
})(function(_ref2) {
  var theme = _ref2.theme, hideSeparator = _ref2.hideSeparator;
  return (0, import_styled_components.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border-top: ", ";\n    ", "\n  "])), hideSeparator ? "none" : "1px solid ".concat(theme.colors.beige[180]), {
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "justifyContent": "flex-end",
    "padding": "1rem",
    "fontFamily": "Circular Std",
    "@media (min-width: 680px)": {
      "flexDirection": "row"
    }
  });
});
var StyledFooterLeftContainer = import_styled_components2.default.div.withConfig({
  displayName: "Dialogstyled__StyledFooterLeftContainer",
  componentId: "sc-1g1a82p-4"
})(function() {
  return (0, import_styled_components.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n  "])), {
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "alignItems": "center",
    "gap": "0.625rem",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0px",
    "paddingBottom": "0px",
    "@media (min-width: 680px)": {
      "padding": "0px"
    }
  });
});
var StyledFooterRightContainer = import_styled_components2.default.div.withConfig({
  displayName: "Dialogstyled__StyledFooterRightContainer",
  componentId: "sc-1g1a82p-5"
})(function() {
  return (0, import_styled_components.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    button {\n      ", "\n    }\n    ", "\n  "])), {
    "justifyContent": "center"
  }, {
    "marginTop": "0.625rem",
    "boxSizing": "border-box",
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "gap": "0.625rem",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0px",
    "paddingBottom": "0px",
    "@media (min-width: 680px)": {
      "marginTop": "0px",
      "flexDirection": "row",
      "alignItems": "center",
      "justifyContent": "flex-end"
    }
  });
});
var StyledBody = import_styled_components2.default.div.withConfig({
  displayName: "Dialogstyled__StyledBody",
  componentId: "sc-1g1a82p-6"
})(function(_ref3) {
  var theme = _ref3.theme, padding = _ref3.padding;
  return (0, import_styled_components.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    padding: ", ";\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.typography.fonts.primary, theme.typography.sizes.medium, theme.typography.weights.regular, padding || "16px 24px", (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        padding: ", ";\n      "])), padding || "24px 40px")), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        padding: ", ";\n        overflow-y: auto;\n        ", "\n      "])), padding || "48px 80px", (0, import_mixins.withStyledScrollBar)())), {
    "boxSizing": "border-box",
    "width": "100%",
    "flexGrow": "1",
    "lineHeight": "1.5rem"
  });
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledBody,
  StyledContentWrapper,
  StyledFooter,
  StyledFooterLeftContainer,
  StyledFooterRightContainer,
  StyledHeader,
  StyledHeaderLeftContainer
});
//# sourceMappingURL=Dialog.styled.js.map